<template>
  <div>
    <h6 class="h6 mb-2">{{ title }}</h6>
    <p class="ma-0 pa-0 grey--text text--darken-1 text-body-2">
      {{ description }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'Subtitle',
  props: {
    title: {
      required: true,
      type: String,
    },
    description: {
      default: '',
      type: String,
    },
  },
}
</script>
